import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Container = styled(Flex).attrs({
  flexDirection: 'column',
  flex: 1,
})`
  overflow: hidden;
`;

export const List = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 1,
})`
  flex: 1;
  overflow-y: auto;
  border: 1px solid ${toColorString(color.base.halfMoon)};
`;

export const Row = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingX: 1,
  paddingY: 0.5,
})`
  gap: 1rem;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${toColorString(color.base.halfMoon)};
  }
`;

export const FieldWrapper = styled(Flex)`
  width: 16rem;
`;
